module.exports = __webpack_public_path__ + "img/kids.6109f950.png";